import { Icon } from '@iconify/react';
import { Link, To } from 'react-router-dom';

import './Navlink.scss';
import clsx from 'clsx';

interface NavlinkProps {
  to: To;
  icon: string;
  label: string;
  active: boolean;
  className?: string;
}

export default function Navlink({ to, icon, label, active, className }: NavlinkProps) {
  return (
    <Link className={clsx('navlink', active && 'active', className)} to={to}>
      <div className="flex items-center gap-2 mb-1 px-0.5">
        <Icon icon={icon} width="1.5rem" height="1.5rem" />
        {/* <span className="whitespace-nowrap">{label}</span> */}
      </div>
    </Link>
  );
}
